import { useEffect, useState } from "react";
import QRCode from "qrcode";
import { Box } from "@mui/material";

interface QRCodeImageProps {
  url: string;
  size?: number;
}

export const QRCodeImage: React.FC<QRCodeImageProps> = ({
  url,
  size = 200,
}) => {
  const [qrCodeDataUrl, setQrCodeDataUrl] = useState<string | null>(null);

  useEffect(() => {
    if (!url) return;

    const generateQRCode = async () => {
      try {
        const dataUrl = await QRCode.toDataURL(url, { width: size, margin: 2 });
        setQrCodeDataUrl(dataUrl);
      } catch (error) {
        console.error("Failed to generate QR code", error);
      }
    };

    generateQRCode();
  }, [url, size]);

  if (!qrCodeDataUrl) {
    return null;
  }

  return (
    <Box display="flex" justifyContent="center" alignItems="center">
      <img src={qrCodeDataUrl} alt="QR Code" width={size} height={size} />
    </Box>
  );
};
